module.exports = __webpack_public_path__ + "static/media/search-icon.c6229807.svg";